"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apiOrderToAppOrder_1 = __importDefault(require("../../libs/apiOrderToAppOrder"));
const appBatchToApiBatch_1 = __importDefault(require("../../libs/appBatchToApiBatch"));
class OrderApi {
    constructor(api) {
        this.api = api;
    }
    getOrder(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}`;
            const response = yield this.api.axiosGo.get(endpoint);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    getOrders({ merchantId, table, status, isFilteredByMe = false, limit = 10, valid = 'true,false', withinCutoffTime = false, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/order';
            const params = Object.assign({ me: isFilteredByMe, merchantID: merchantId, table,
                status,
                valid, page: 1, size: limit }, withinCutoffTime && { withinCutoffTime: true });
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data.map(apiOrderToAppOrder_1.default);
        });
    }
    createOrder(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/order';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    joinOrder(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}/join`;
            const response = yield this.api.axiosGo.post(endpoint);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    submitBatch(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = appBatchToApiBatch_1.default(params);
            const endpoint = `/c/order/${params.orderId}/submit`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    requestPaying(orderId, payment) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}/pay`;
            const response = yield this.api.axiosGo.put(endpoint, payment);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    requestService(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}/service`;
            const response = yield this.api.axiosGo.put(endpoint);
            return apiOrderToAppOrder_1.default(response.data);
        });
    }
    getRecentPaymentInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/c/payment/recent');
            return response.data;
        });
    }
    createWechatPayment(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosNode.post('/c/payment/qfpay/wechatpay', data);
            return response.data;
        });
    }
}
exports.default = OrderApi;
//# sourceMappingURL=Order.js.map